<div class="edit-page-root-container employee-edit-root-container">
    <div class="page-content">
        <div class="page-header">
            <button mat-button class="nav-button" (click)="onBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <div class="title">
           ATTENDANCE EXPORT
            </div>
            <div class="action-btn-container">
  <button mat-flat-button color="primary" class="btn-export" (click)="onExportAttendanceProceed()">Export hours and comments</button>
</div>
        </div>
        <div class="page-details">
            <form class="edit-form">
                <div class="detail-section">
                    <div class="content-container">
                       <section tabindex="0" class="final-page">
                        <!-- Header Summary -->
                        <div>
                            <b>
                                Payroll Group: 
                                {{ attendanceHeader?.payroll_group_code 
                                    || attendanceHeader?.payrollgroup_code 
                                    || proceedData?.payload?.payroll_group_code
                                    || proceedData?.payload?.payrollgroup_code
                                    || proceedData?.payload?.payroll_group_id
                                    || proceedData?.data?.employee_attendance_export?.[0]?.payrollgroup_code 
                                    || proceedData?.data?.payroll_group_code 
                                    || proceedData?.data?.payrollgroup_code 
                                    || '-' }}
                                &nbsp; Year: 
                                {{ attendanceHeader?.year 
                                    || proceedData?.payload?.year
                                    || proceedData?.data?.year 
                                    || proceedData?.data?.employee_attendance_export?.[0]?.year 
                                    || '-' }}
                                &nbsp; Week: 
                                {{ attendanceHeader?.weekNo 
                                    || proceedData?.payload?.weekNo
                                    || proceedData?.data?.weekNo 
                                    || proceedData?.data?.employee_attendance_export?.[0]?.weekNo 
                                    || '-' }}
                                ({{ attendanceHeader?.start_date 
                                    || proceedData?.payload?.start_date
                                    || proceedData?.data?.start_date 
                                    || proceedData?.data?.employee_attendance_export?.[0]?.start_date 
                                    || dateRange }} 
                                - 
                                {{ attendanceHeader?.end_date 
                                    || proceedData?.payload?.end_date
                                    || proceedData?.data?.end_date 
                                    || proceedData?.data?.employee_attendance_export?.[0]?.end_date 
                                    || dateRange }})
                            </b>
                        </div>

                        <ng-container *ngIf="hasExportData(); else noData">
                          <p>The selected weekly attendance data is good for Export</p>
                        </ng-container>
                        <ng-template #noData>
                          <p>No records to export, There are no comments</p>
                        </ng-template>
                    </section>
                       
                    </div>
                </div>
             

              


              

            </form>
        </div>
    </div>
</div>